import { useMemo } from 'react'

import {
  getCssText,
  useThemeContext,
} from '@tribeplatform/react-ui-kit/ThemeProvider'

interface UseDarkThemeCSSProps {
  elementId: string
}

export const useDarkThemeStyles = ({ elementId }: UseDarkThemeCSSProps) => {
  const { theme, style, typography } = useThemeContext()

  const darkThemeStyles = useMemo(
    () =>
      getCssText({
        theme,
        style,
        typography,
        userColorScheme: 'dark',
        /**
         * @todo: get actual network dark theme as it can be dark2 as well.
         */
        networkColorScheme: { mode: 'single', default: 'dark1' },
        /**
         * Scopes theme to this element only.
         */
        elementId,
      }),
    [theme, style, typography, elementId],
  )
  return darkThemeStyles
}
